import { render, staticRenderFns } from "./notice copy.vue?vue&type=template&id=03ffa00a&scoped=true"
import script from "./notice copy.vue?vue&type=script&lang=js"
export * from "./notice copy.vue?vue&type=script&lang=js"
import style0 from "./notice copy.vue?vue&type=style&index=0&id=03ffa00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ffa00a",
  null
  
)

export default component.exports